import { configureStore } from '@reduxjs/toolkit';
import commonReducer from '../reducer/rootReducer';
import userReducer from '../reducer/userReducer';
import installTaskReducer from '../reducer/installTaskReducer';
import collectionTaskReducer from '../reducer/collectionTaskReducer';
import transportTaskReducer from '../reducer/transportTaskReducer';
import processingTaskReducer from '../reducer/processingTaskReducer';
import exportTaskReducer from '../reducer/exportTaskReducer';
import historyTaskReduce from '../reducer/taskHistoryReducer';
import { useDispatch } from 'react-redux';
import inventoryProgressSlice from 'reducer/inventoryProgressReducer';
import inventoryPerformanceSlice from 'reducer/inventoryPerformanceReducer';
import trackingSlice from 'reducer/trackingReducer';
import containerSlice from 'reducer/containerReducer';
import containerCollectionSlice from 'reducer/containerCollectionReducer';
import unitIntegrationReducer from 'reducer/unitIntegrationReducer';
import externalApiKeyReducer from 'reducer/externalApiKeyReducer';
import externalIpWhitelistReducer from 'reducer/externalIpWhitelistReducer';

export const store = configureStore({
    devTools: true,
    reducer: {
        common: commonReducer,
        user: userReducer,
        installTask: installTaskReducer,
        collectionTask: collectionTaskReducer,
        transportTask: transportTaskReducer,
        processingTask: processingTaskReducer,
        exportTask: exportTaskReducer,
        historyTask: historyTaskReduce,
        inventoryProgress: inventoryProgressSlice,
        inventoryPerformance: inventoryPerformanceSlice,
        tracking: trackingSlice,
        container: containerSlice,
        containerCollection: containerCollectionSlice,
        unitIntegration: unitIntegrationReducer,
        externalApiKey: externalApiKeyReducer,
        externalIpWhitelist: externalIpWhitelistReducer,
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export const appDispatch: AppDispatch = store.dispatch;
